import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // Import Link for navigation and useNavigate
import "bootstrap/dist/css/bootstrap.min.css";

function Screen() {
  const [loading, setLoading] = useState(false); // Loading state
  const [selectedMatch, setSelectedMatch] = useState(""); // To display selected match
  const [activeMenu, setActiveMenu] = useState(""); // State for managing active menu in sidebar
  const navigate = useNavigate(); // React Router's navigation hook

  const handleMatchClick = async (matchName) => {
    setLoading(true);
    setSelectedMatch(`Fetching data for ${matchName}...`);

    //  try {

    // Simulating an API call (replace with actual API)
    // const response = await fetch(`https://webcore.hunzagroupofindustries.com.pk/api/OYardAG`);
    // if (!response.ok) {
    //   throw new Error("Failed to fetch data");
    // }

    // const result = await response.json();

    // Save data to localStorage or pass it via state (replace with your data handling logic)
    //  localStorage.setItem("matchData", JSON.stringify(result));

    // Navigate to the new screen and pass the match name
    navigate(`/${matchName.toLowerCase().replace(" ", "-")}`);
    //  } catch (error) {
    //    setSelectedMatch(`Error fetching data for ${matchName}: ${error.message}`);
    //   } finally {
    //    setLoading(false);
    //  }
  };

  return (
    <div className="d-flex vh-100">
      {/* Sidebar */}

      {/* Main Content Area */}
      <main className="flex-grow-1 p-4" style={{ backgroundColor: "#f8f9fa" }}>
        <h1>Wellcome Unit II</h1> <br></br>
        {/* Match Options */}
        <div className="container mt-5">
          <div className="row">
          <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-primary d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                  position: "relative", // Allows positioning of the image inside the button
                }}
                onClick={() => handleMatchClick("Flow")}
              >
                {/* Image or GIF inside the button */}
                {/* <img
                  src="2.gif" // Replace with your GIF image path
                  alt="Flow Icon"
                  style={{
                    position: "absolute", // Position the image absolutely inside the button
                    top: "50%", // Vertically center the image
                    left: "50%", // Horizontally center the image
                    transform: "translate(-50%, -50%)", // Offset the image so it's truly centered
                    maxWidth: "100%", // You can adjust the size of the image as needed
                    maxHeight: "100%", // Ensure the image fits within the button's height
                  }} 
                />*/}
                Flow
              </div>
            </div>
            {/* Match A */}
            <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-danger d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("Crushing")}
              >
                Crushing
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-primary d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("DataScreen")}
              >
                Yard Summary
              </div>
            </div>

            {/* Match B */}
            <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-success d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("EstimatedAG")}
              >
                Estimated Avg. Cost of Yard Balance
              </div>
            </div>

          

            {/* Match D */}
          </div>
          <div className="row">
            {/* Match A */}
            <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-dark text-white d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("stock")}
              >
                Sugar In Process
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-warning text-white d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("labana")}
              >
                Lab Analysis
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-secondary text-white d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("sugarcost")}
              >
                Sugar Cost
              </div>
            </div>
            {/* <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-primary d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("VehicleList")}
              >
              Date Wise ELP Registration (Graph)
              </div>
            </div> */}

            {/* <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-primary d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("Flow")}
              >
                Flow
              </div>
            </div> */}

<div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-danger d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("elpregistrationdate")}
              >
                ELP Registration
              </div>
            </div>
          </div>
          <div className="row">
            
            <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-danger d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("elpregistrationway")}
              >
              On The Way
              </div>
            </div>
              {/* Match C */}
              <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-info d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("AgAs")}
              >
                On Date To Date Avg. Cost
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div
                className="border text-white text-center p-4 bg-warning d-flex justify-content-center align-items-center"
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  borderRadius: "10px",
                  height: "150px", // Ensure consistent height
                }}
                onClick={() => handleMatchClick("ScAnalysis")}
              >
                SugarCane Analysis
              </div>
            </div>

           

          </div>
          {/* Match A */}

          {/* Loading or Selected Match Info */}
          <div className="mt-4">
            {loading && <div className="alert alert-warning">Loading...</div>}
            {!loading && selectedMatch && (
              <div className="alert alert-info">{selectedMatch}</div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

export default Screen;
